module.exports = __webpack_public_path__ + "img/single_pictures_6_1.aba7254e.jpg";